const NotFound = () => {
  return (
    <div className="h-[100vh] w-[100vw] flex justify-center items-center font-extrabold text-[30px]">
      404 Page
    </div>
  );
};

export default NotFound;
